var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-field-label-pane" },
    [
      _c("FieldFilterInput", {
        attrs: { count: _vm.controller.fieldFilterCount },
        model: {
          value: _vm.controller.fieldFilterString,
          callback: function ($$v) {
            _vm.$set(_vm.controller, "fieldFilterString", $$v)
          },
          expression: "controller.fieldFilterString",
        },
      }),
      _vm._l(_vm.controller.displayFieldGroups, function (group) {
        return _c(
          "div",
          { key: group.type, staticClass: "custom-field-label-pane__group" },
          [
            _vm.controller.isShowFieldGroupHeader(group.type)
              ? _c(
                  "div",
                  {
                    staticClass: "custom-field-label-pane__group-header",
                    on: {
                      click: function ($event) {
                        return _vm.controller.toggleTabExpandStatus(group.type)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "PtCustomFieldLabelPane.fieldMainType." + group.type
                          )
                        )
                      ),
                    ]),
                    _c("PtIcon", {
                      staticClass:
                        "custom-field-label-pane__group-header-arrow-icon",
                      attrs: {
                        icon: _vm.controller.tabExpandStatus[group.type]
                          ? "SolidArrowUp"
                          : "SolidArrowRight",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.controller.tabExpandStatus[group.type]
              ? [
                  group.fields && group.fields.length
                    ? _vm._l(group.fields, function (field) {
                        return _c("FieldContainer", {
                          key: field.field_id,
                          attrs: {
                            field: field,
                            controller: _vm.controller,
                            "field-main-type":
                              _vm.controller.getFieldMainType(field),
                          },
                        })
                      })
                    : [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-field-label-pane__group-no-data",
                          },
                          [
                            _vm._t(
                              "noData",
                              function () {
                                return [
                                  _c("PtIcon", {
                                    attrs: { icon: "SolidNoDataTip" },
                                  }),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.controller.generateFieldGroupEmptyText(
                                          group.type
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              null,
                              {
                                fieldMainType: group.type,
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                ]
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }